import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { UpdateSrtStream } from '../../../connection/video';
import { GreenroomState as GS } from '../../../stores/types/types';
import { SrtStream } from '../../../stores/reducers/video';

interface LocalAudio {
	localVolume: number;
	localMuted: boolean;
}

export default function useAudioControls(srtStream: SrtStream | null | undefined) {
	if (!srtStream) return { localVolume: 0, localMuted: false };

	const { id, volume, muted } = srtStream;

	const token = useSelector((state: GS) => state.SessionReducer.token);
	const meeting = useSelector((state: GS) => state.SessionReducer.meeting);

	const [audio, setAudio] = useState<LocalAudio>({ localVolume: volume, localMuted: muted });
	const { localVolume, localMuted } = audio;

	const volumeDebounce = useRef<NodeJS.Timeout | null>(null);

	const updateSrtStream = (newVolume: number, newMuted: boolean) => {
		if (!token || !meeting) return;
		UpdateSrtStream(
			token,
			meeting.meeting,
			id,
			{ volume: newVolume, muted: newMuted },
		);
	};

	const handleMuteChange = () => {
		const newMuted = !localMuted;
		setAudio({ localVolume, localMuted: newMuted });
		updateSrtStream(localVolume, newMuted);
	};

	const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newVolume = parseFloat(e.target.value);
		setAudio({ localVolume: newVolume, localMuted: false });
		if (volumeDebounce.current) { clearTimeout(volumeDebounce.current); }
		volumeDebounce.current = setTimeout(() => {
			updateSrtStream(newVolume, false);
		}, 100);
	};

	useEffect(() => {
		if (volume !== localVolume || muted !== localMuted) {
			setAudio({ localVolume: volume, localMuted: muted });
		}
	}, [volume, muted]);

	return {
		localVolume,
		localMuted,
		handleMuteChange,
		handleVolumeChange,
	};
}
